<template>
	<AppShop />
</template>

<script>
import AppShop from "@/shop/components/AppShop.vue";

export default {
	name: "ShopContainer",
	components: {AppShop},
	mounted() {
	}
}
</script>

<style scoped>

</style>